<template>
    <b-container class="hkiarace-event-category-detail" v-if="!!eventCategory">
        <b-row>
            <b-col>
                <h2>{{$t('admin_event_category.edit_category')}}</h2>
            </b-col>
        </b-row>
        <hr>
        <b-card no-body>
            <b-tabs card @input="tabChanged" v-model="tabIndex">
                <b-tab :title="$t('register.basic_info')">
                    <b-row>
                        <b-col>
                            <b-form class="hkiarace-event-category-edit-form">
                                <b-form-group :label="$t('admin_event_category.name_en')"
                                              horizontal>
                                    <b-form-input v-model="eventCategory.name_en"></b-form-input>
                                </b-form-group>
                                <b-form-group :label="$t('admin_event_category.name_zh')"
                                              horizontal>
                                    <b-form-input v-model="eventCategory.name_zh"></b-form-input>
                                </b-form-group>
                                <b-form-group :label="$t('admin_event_category.color')"
                                              horizontal>
                                    <swatches-picker :value="eventCategory.color" @input="colorSelected"></swatches-picker>
                                </b-form-group>

                                <b-form-group :label="$t('admin_event_category.layout_style')" horizontal>
                                    <b-form-radio-group v-model="eventCategory.layout_style">
                                        <b-form-radio :value="1">{{$t('admin_event_category.layout_style_list')}}</b-form-radio>
                                        <b-form-radio :value="2">{{$t('admin_event_category.layout_style_grid')}}</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-form>

                            <b-button @click="saveEventCategory" variant="primary">{{$t('save')}}</b-button>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEdit, faSearch} from '@fortawesome/free-solid-svg-icons'
    import {Swatches} from 'vue-color'

    library.add(faEdit, faSearch);

    export default {
        name: 'HkiaraceEventCategoryDetail',
        components: {
            'swatches-picker': Swatches,
        },
        data() {
            return {
                tabIndex: 0,
                eventCategoryId: this.$route.params.eventCategoryId,
                eventCategory: null,
            }
        },
        mounted() {
            this.getEventCategory();

            var v = this;
            setTimeout(function () {
                v.tabIndex = parseInt(v.$route.query.t || "0");
            }, 50);

        },
        computed: {},
        methods: {
            getEventCategory() {
                this.$callAPI('hkiarace/event_category/', {category_id: this.eventCategoryId}, function (response) {
                    this.eventCategory = response.body.category;
                });
            },
            colorSelected(color) {
                this.eventCategory.color = color.hex;
            },
            saveEventCategory() {
                if (!this.eventCategory.name_en) {
                    this.$showAlertMessage("Please input all fields");
                    return;
                }

                this.$callAPI('hkiarace/event_category/edit/', {
                    id: this.eventCategoryId,
                    name_en: this.eventCategory.name_en,
                    name_zh: this.eventCategory.name_zh,
                    color: this.eventCategory.color,
                    layout_style: this.eventCategory.layout_style,
                }, function (response) {
                    this.$showAlertMessage('Info Saved');
                    this.getEventCategory();
                })
            },
            tabChanged(tabIndex) {
                this.$router.replace({name: 'hkiarace-event-category-detail', params: this.$route.params, query: {...this.$route.query, t: tabIndex}})
            },
        },
    }
</script>

<style scoped lang="less">

</style>
